export default function BuildTable(instance) {
    const tableEl = instance.coverageToolResultsTable;

    // Declare variables
    // let input;
    let filter;
    let table;
    let tr;
    let td;
    let i;
    let txtValue;
    filter = instance.coverageToolResultsFilter.value.toUpperCase();
    table = tableEl;
    tr = table.getElementsByTagName("tr"); // Loop through all table rows, and hide those who don't match the search query

    filter.length ? instance.coverageToolResultsView.classList.add("table-filtered") : instance.coverageToolResultsView.classList.remove("table-filtered");

    let count = 0;

    for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];

        if (td) {
            txtValue = td.textContent || td.innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                tr[i].style.display = "";
                count++;
            } else {
                tr[i].style.display = "none";
            }
        }
    }
    if (!count) {
        instance.coverageToolResultsView.classList.add("no-results");
    } else {
        instance.coverageToolResultsView.classList.remove("no-results");
    }
}
